<!--
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-06-12 17:25:17
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2025-10-28 13:20:56
 * @FilePath: \betdoce-web\src\components\PinduoduoDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <v-dialog
    :model-value="dialog"
    @update:model-value="(value: boolean) => emit('close', value)"
    max-width="500"
    :persistent="false"
    @click:outside="closeDialog"
  >
    <div class="pdd-activity" :class="{ help: 'help' === 'help' }">
      <!-- 添加中獎提示彈框 -->
      <!-- <div class="winning-alert" v-if="showWinningAlert">
        <div class="winning-content">
          <div class="winning-message">{{ winningData.message }}</div>
        </div>
      </div> -->

      <!-- 添加加載動畫 -->
      <v-overlay
        :model-value="loading"
        class="align-center justify-center"
        persistent
      >
        <img
          src="@/assets/images/h5/loading.gif"
          alt="loading"
          class="global-loading-img"
        />
        <!-- <v-progress-circular
           color="#50EF7C"
          indeterminate
          size="64"
        ></v-progress-circular> -->
      </v-overlay>

      <!-- 助力卡片 -->
      <div class="reward-card-help">
        <!-- <div class="ok-img">
            <img src="@/assets/images/h5/pdd-ok-tp.png" />
          </div> -->
        <div class="reward-card-top">
          <div class="reward-progress">Convide amigos para ganhar bônus</div>
          <div class="reward-amount">
            R<span style="font-size: 30px">$</span>
            {{ activityStatus?.initiator_bonus_amount / 100 }}
          </div>
          <!-- <div class="progress-tip"></div> -->
          <!-- <div class="progress-bar-wrap">
            <v-progress-linear
              class="progress-bar"
              :model-value="activityStatus?.current_progress"
              color="#faab59"
              height="10"
              rounded
            ></v-progress-linear>
            <span class="progress-tip"
              >Faltam apenas
              {{ (100 - activityStatus?.current_progress).toFixed(2) }}% para
              concluir</span
            >
          </div> -->
          <v-icon
            class="icon-tip"
            icon="mdi-alert-circle-outline"
            @click="() => (showRule = true)"
          ></v-icon>
        </div>
        <div class="reward-card-bottom-bg">
          <div class="reward-card-bottom">
          
            <div class="desc-text">
              Convide 1 pessoa para ajudar：<span style="font-size: 30px"
                >R</span
              >$
              {{ activityStatus?.booster_bonus_amount / 100 || 0 }}
            </div>

            <v-btn class="activity-main-btn" @click="hendleShare">
              Convide amigos para ajudar
            </v-btn>
            <p class="countdown">tempo restante {{ formatTime(countdown) }}</p>
          </div>
        </div>
      </div>
    </div>
    <RuleDialog
      :visible.sync="showRule"
      title="Regras de Atividade"
      :content="activityStatus?.activity_text"
      @update:visible="handleRuleDialogClose"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import RuleDialog from "@/components/RuleDialog.vue";
import { updateMetaTags } from "@/utils";
import { showError, showSuccess } from "@/utils/toast";
import { computed, ref, watch } from "vue";
import { datetimeDefaultFormate, getBrazilTime } from "@/utils/format";
import moment from "moment";

const props = defineProps({
  activityStatus: Object,
  show: Boolean,
});
const dialog = computed(() => {
  return props.show;
});
const emit = defineEmits(["close"]);

const countdownTimer = ref(); // 倒计时定时器
const countdown = ref(); // 倒计时时间
const loading = ref(false);

function closeDialog() {
  emit("close");
}
// 格式化时间
function formatTime(ms: number): string {
  if (!ms || ms <= 0) return "00:00:00";
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}
// 复制到剪贴板 - 移动端优化版本
async function copyToClipboard(text: string): Promise<boolean> {
  console.log("开始复制内容:", text.substring(0, 100) + "...");
  console.log("完整内容:", text);

  // 检测移动端
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);



  // 强制清理所有可能的临时元素
  const existingElements = document.querySelectorAll(
    "textarea[data-clipboard-temp], input[data-clipboard-temp]"
  );
  existingElements.forEach((el) => el.remove());

  // 方法1: 尝试现代剪贴板API
  try {
    if (navigator.clipboard && window.isSecureContext) {
      console.log("使用现代剪贴板API");

      // 移动端需要更长的延迟
      const delay = isMobile ? 50 : 10;

      // 先清空剪贴板
      await navigator.clipboard.writeText("");
      await new Promise((resolve) => setTimeout(resolve, delay));

      // 再写入新内容
      await navigator.clipboard.writeText(text);
      await new Promise((resolve) => setTimeout(resolve, delay * 2));

      console.log("现代API复制完成");
      return true;
    }
  } catch (error) {
    console.log("现代API失败:", error);
  }

  // 方法2: Fallback到传统方法 - 移动端优化
  console.log("使用传统复制方法");
  return new Promise((resolve) => {
    // 移动端使用textarea，桌面端使用input
    const element = isMobile
      ? document.createElement("textarea")
      : document.createElement("input");

    if (!isMobile) {
      (element as HTMLInputElement).type = "text";
    }

    element.value = text;
    element.setAttribute("data-clipboard-temp", "true");

    // 移动端需要特殊的样式处理
    if (isMobile) {
      element.style.position = "fixed";
      element.style.left = "0";
      element.style.top = "0";
      element.style.width = "1px";
      element.style.height = "1px";
      element.style.padding = "0";
      element.style.border = "none";
      element.style.outline = "none";
      element.style.boxShadow = "none";
      element.style.background = "transparent";
      element.style.fontSize = "16px"; // 防止iOS缩放
      element.style.opacity = "0";
      element.style.zIndex = "-1";
    } else {
      element.style.position = "fixed";
      element.style.left = "-9999px";
      element.style.top = "-9999px";
      element.style.opacity = "0";
      element.style.zIndex = "-1";
    }

    document.body.appendChild(element);

    // 强制刷新DOM
    element.offsetHeight;

    const delay = isMobile ? 200 : 100;
    setTimeout(() => {
      try {
        element.focus();
        element.select();

        if (element.setSelectionRange) {
          element.setSelectionRange(0, element.value.length);
        }

        // 移动端需要更多尝试
        const maxAttempts = isMobile ? 5 : 3;
        let success = false;

        for (let i = 0; i < maxAttempts; i++) {
          try {
            success = document.execCommand("copy");
            if (success) {
              console.log(`复制成功，尝试次数: ${i + 1}`);
              break;
            }
          } catch (e) {
            console.log(`复制尝试 ${i + 1} 失败:`, e);
          }

          // 移动端在重试前稍作等待
          if (isMobile && i < maxAttempts - 1) {
            // 使用同步等待，避免async问题
            const start = Date.now();
            while (Date.now() - start < 50) {
              // 简单的同步等待
            }
          }
        }

        console.log("传统方法复制结果:", success);
        resolve(success);
      } catch (error) {
        console.log("传统方法失败:", error);
        resolve(false);
      } finally {
        // 清理元素
        const cleanupDelay = isMobile ? 300 : 200;
        setTimeout(() => {
          if (element.parentNode) {
            element.parentNode.removeChild(element);
          }
        }, cleanupDelay);
      }
    }, delay);
  });
}

// 倒计时定时器
function startRechargeCountdown() {
  clearRechargeTimer();
  countdownTimer.value = window.setInterval(() => {
    if (countdown.value > 0) {
      countdown.value -= 1000;
    } else {
      clearRechargeTimer();
      countdown.value = 0;
    }
  }, 1000);
}
function clearRechargeTimer() {
  if (countdownTimer.value) {
    window.clearInterval(countdownTimer.value);
    countdownTimer.value = null;
  }
}
// 分享tg群
async function hendleShare() {
  const shareUrl = props.activityStatus?.share_link;

  const success = await copyToClipboard(shareUrl);
  if (success) {
    updateMetaTags(shareUrl);
    showSuccess("Link copiado para a área de transferência!");
  } else {
    showError("Falha ao copiar o link");
  }
  try {
    // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    // if (isIOS && activityStatus.value?.tg_link) {
    //   setTimeout(() => {
    //     window.location.href = activityStatus.value.tg_link;
    //   }, 100);
    // } else if (activityStatus.value?.tg_link) {
    //   window.open(activityStatus.value.tg_link, "_blank");
    // }
  } catch (error) {
    console.error("获取人工客服链接失败:", error);
  }
}
// 规则设置
const showRule = ref(false);
function handleRuleDialogClose(val: boolean) {
  showRule.value = val;
}
// function initializeActivityData() {}
watch(dialog, (newValue) => {
  if (newValue) {
    countdown.value =
      props.activityStatus?.expire_time -
      datetimeDefaultFormate(
        moment(getBrazilTime()).format("YYYY-MM-DD HH:mm:ss")
      );
    startRechargeCountdown();
  } else {
    clearRechargeTimer();
  }
});
</script>

<style lang="scss" scoped>
.help {
  background-size: 100% auto !important;
}
.global-loading-img {
  width: 150px;
  height: 150px;
}
// 中獎提示彈框樣式
.winning-alert {
  position: fixed;
  top: 30px;
  /* 距離頂部一些距離 */
  left: 50%;
  transform: translateX(-50%);
  /* 水平居中 */
  z-index: 9999;
  background: rgba(0, 0, 0, 0.4);
  /* 黃色漸變 */
  border-radius: 12px;
  /* 圓角 */
  padding: 12px 20px;
  /* 調整內邊距 */
  width: 90%;
  /* 設置寬度 */
  max-width: 320px;
  /* 最大寬度 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* 添加陰影 */

  .winning-content {
    text-align: center;

    .winning-message {
      font-family: FZLanTingHeiDB-SC;
      /* 確保字體一致 */
      font-weight: 800;
      /* 加粗 */
      color: #fff;
      /* 紅色字體 */
      line-height: 1.4;
      /* 行高 */
    }

    .winning-count {
      font-size: 16px;
      margin-bottom: 4px;
    }

    .winning-message {
      font-size: 14px;
    }
  }
}

.activity-main-btn {
  padding: 14px;
  height: auto;
  width: 100%;
  background: url("@/assets/images/h5/activity-button.png") no-repeat;
  /* Assuming gradient from image */
  background-size: 100% 100%;
  font-size: 18px;
  color: #333333;
  border-radius: 24px;
  box-shadow: none !important;
  text-transform: none;
  font-weight: 800;
  text-shadow: 0 2px 8px rgba(255, 153, 0, 0.1);
  transition: background 0.2s;
  :deep(.v-btn__overlay) {
    background: none !important;
    border: none;
  }
}

.activity-main-btn :deep(.v-btn__content) {
  white-space: normal !important;
  /* Ensure text wraps */
  line-height: 1.2;
  /* Explicit line height */
}

:deep(.v-overlay__content) {
  // background-color: #508336;
  border-radius: 20px;
}

.pdd-activity {
  min-height: 50vh;
  // background: url("@/assets/images/h5/pdd-bg.png") no-repeat center center;
  // background-size: 100% 100%;
  padding: 20px;
  position: relative;
  overflow: hidden;
  // 添加安全区域padding
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  border-radius: 20px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }

  .reward-card {
    // position: relative;
    .icon-tip {
      color: #008f45;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }

    .reward-title-tip {
      font-family: RockoFLF, RockoFLF;
      font-weight: bold;
      font-size: 20px;
      color: #005c2c;
      // line-height: 69px;
      text-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .reward-amount {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 30px;
      font-family: Alibaba PuHuiTi;
      font-weight: 800;
      color: #005c2c;
      text-align: center;
      width: 100%;
    }

    .open-button {
      width: 90px;
      height: 90px;
      background: url("@/assets/images/h5/pdd-open-btn.png") no-repeat center
        center;
      background-size: contain;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      text-align: center;
      transition: transform 0.2s ease;

      &:active {
        transform: scale(0.95);
      }

      span {
        opacity: 1;
        font-size: 1.2rem;
        font-weight: 1000;
        text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
      }
    }

    .open-tip {
      font-size: 13px;
      color: #005c2c;
      background: url("@/assets/images/pdd-open-tip.png");
      background-size: 100% 100%;
      border-radius: 6px;
      padding: 4px 6px;
      display: inline-block;
      font-weight: 600;
      text-align: center;
      margin: 0 auto;
    }

    &.shake {
      animation: shakeCard 0.8s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    }
  }

  .reward-card-help {
    background: transparent;
    box-shadow: none;
    padding: 0;
    width: 100%;
    max-width: 360px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;

    .reward-card-top {
      width: 90%;
      background: #005c2c;
      border-radius: 24px 24px 0 0;
      box-shadow: 0 4px 16px rgba(255, 153, 0, 0.18);
      padding: 32px 24px 18px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      border: 10px solid #008f45;
      border-bottom: none;
      margin-bottom: -50px;
      position: relative;

      // z-index:1;
      .icon-tip {
        color: #008f45;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }
    }
    .need_recharge {
      margin-bottom: -70px;
      padding: 32px 24px 32px 24px;
    }
    .reward-amount {
      font-size: 48px;
      color: #fff;
      margin-bottom: 8px;
      letter-spacing: 1px;
      font-family: RockoFLF, RockoFLF;
      font-weight: bold;
      text-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
    }

    .reward-progress {
      font-size: 22px;
      color: #fff;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .progress-bar-wrap {
      width: 100%;
      margin-bottom: 8px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .progress-bar {
      width: calc(100% - 16px);
      margin-left: 8px;
      overflow: inherit;

      :deep(.v-progress-linear__background) {
        background: #005c2c !important;
        opacity: 1 !important;
        border-radius: 5px;
      }

      :deep(.v-progress-linear__determinate) {
        border-radius: 5px !important;
        // background: #fff !important;
        background: linear-gradient(90deg, #2f3c2a 0%, #45b032 100%);
        box-shadow: inset 0px 0px 4px 0px rgba(255, 255, 255, 0.5);
        &::after {
          content: "";
          position: absolute;
          display: block;
          background: url("@/assets/images/h5/progress-icon-bg.png") no-repeat
            center;
          background-size: 100% 100%;
          width: 21px;
          height: 21px;
          right: -10.5px;
          top: -6px;
          z-index: 9999;
          color: #fff;
          font-size: 0.7rem;
          font-weight: 800;
          line-height: 21px;
          text-align: center;
        }
      }
    }

    .progress-tip {
      font-size: 14px;
      color: #fff;
      margin-top: 2px;
      text-shadow: 0 1px 4px rgba(255, 153, 0, 0.18);
    }

    .reward-card-bottom-bg {
      width: 100%;
      background: #ecfdc7;
      // z-index: 1;
      border-radius: 40px;
      margin-top: -40px;
      box-shadow: 0 8px 32px -8px rgba(0, 0, 0, 0.4);

      .reward-card-bottom {
        margin-top: 40px;
        width: 100%;
        border-radius: 0 0 24px 24px;
        position: relative;
        // overflow: hidden;
        background-image: url("@/assets/images/bottom-bg2.png");
        background-size: 100% 100%;
        // box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
        padding: 60px 24px 24px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        // border-bottom-left-radius: 100% 80px;
        // border-bottom-right-radius: 100% 80px;
        // border-top-left-radius: 50% 40px;
        // border-top-right-radius: 50% 40px;
        // z-index: 1;
        .countdown {
          font-weight: 500;
          font-size: 16px;
          color: #005c2c;
          line-height: 30px;
        }

        .friend-avatars {
          display: flex;
          justify-content: center;

          .empty-friends {
            font-family: FZLanTingHeiDB-SC;
            // font-weight: 800; /* Made bolder */
            font-size: 0.8rem;
            color: #005c2c;
            /* Adjusted color to red */
            text-align: center;
            margin: 30px 0 40px 0;
          }

          .avatar-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .avatar {
              width: 50px;
              height: 50px;
              margin-right: 10px;
            }
          }

          .dot-more {
            width: 50px;
            height: 50px;
            margin-left: 5px;
          }
        }
      }
      .need_recharge-bottom {
        padding: 60px 24px 0px 24px;
        .activity-main-btn {
          margin-top: 0px;
        }
      }
      // .reward-card-bottom::before{
      //   content: "";
      //   position: absolute;
      //   display: block;
      //   top:-40px;
      //   width: 94%;
      //   height: 40px;
      //   background: #ECFDC7;
      //   z-index: 1;
      // }
    }

    .desc-text {
      font-size: 18px;
      color: #005c2c;
      font-weight: 700;
      margin-bottom: 10px;
      text-align: center;
      text-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
    }

    // .activity-main-btn {
    //   width: 100%;
    //   max-width: 320px;
    //   height: 54px;
    //   background: linear-gradient(180deg, #ff7c3a 0%, #ff3a3a 100%);
    //   color: #fff;
    //   font-size: 17px;
    //   font-weight: 800;
    //   border-radius: 32px;
    //   box-shadow: 0 4px 16px rgba(255, 58, 58, 0.18);
    //   margin-top: 8px;
    //   text-shadow: 0 2px 8px rgba(255, 153, 0, 0.1);
    //   letter-spacing: 1px;
    //   text-align: center;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   transition: background 0.2s;
    // }

    // .activity-main-btn:active {
    //   background: linear-gradient(180deg, #ff3a3a 0%, #ff7c3a 100%);
    // }
  }

  .card-ok {
    bottom: 22vh;

    .ok-img {
      position: absolute;
      top: -220px;
      z-index: 999;
      width: 300px;
      height: 300px;
      overflow: hidden;
      left: calc(50% - 150px);
      text-align: center;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("@/assets/images/h5/ok-img-bg.png") no-repeat center;
        background-size: 100% 100%;
        background-position: top;
        animation: rotateBackground 8s linear infinite;
        z-index: -2;
      }

      img {
        margin-top: 60px;
        width: 160px;
        position: relative;
        z-index: 1;
      }
    }

    .reward-header {
      // height: 160px;
      top: -90px;

      .header-radius {
        // height: 160px;
      }

      .header-main {
        // height: 160px;
      }

      .amount-text {
        // margin-top: 60px;
        font-size: 60px !important;
      }
    }

    .triangle {
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid #fee2a2;
      margin: 0 auto 14px;
    }
  }

  .reward-box {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: auto;
    bottom: 22vh;
    height: 180px;
    right: -45px;
    z-index: 1;
    background: url("@/assets/images/h5/bg-box.png") no-repeat center bottom;
    background-size: 100% auto;
    margin-bottom: 6px;
  }
}

@keyframes shakeCard {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

@keyframes coinBurst {
  0% {
    transform: translate(0, 0) rotate(0) scale(0);
    opacity: 0;
  }

  10% {
    opacity: 1;
    transform: translate(0, 0) rotate(0) scale(var(--scale));
  }

  100% {
    transform: translate(var(--x), var(--y)) rotate(var(--rotate))
      scale(var(--scale));
    opacity: 0;
  }
}

@keyframes coinRotate {
  from {
    transform: rotateY(0deg);
  }

  to {
    transform: rotateY(360deg);
  }
}

@keyframes rotateBackground {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
